import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography, Grid,
} from "@mui/material";
import React, { useContext } from "react";
import { PRIMARY_COLOR_DarkNavyBlue } from "../../../constants/Colors";
import CustomTextField from "../../../general_components/CustomTextField";
import LoadingButton from "../../../general_components/LoadingButton";
import Editor from "../../subscribers/components/EmailEditor";
import { convertToRaw } from "draft-js";
import { useTheme } from "@mui/styles";
import AddCardImage from "./AddCardImage";
import AddGallaryImages from "./AddGallaryImages";
import CustomTextFieldWithChip from "../../../general_components/CustomInputChip";
import { TeamContext } from "../../../contexts/TeamsContext";

export default function ProjectModal(props) {

  const { open, handleClose, text, handlerFunction, id,
    projectGallaryImages, setProjectGallaryImages,
    projectGallaryRawImages, setprojectGallaryRawImages,
    isNewsFile, setIsNewsFile, companyName, setCompanyName,
    projectLoaction, setProjectLoaction, projectTypology,
    setProjectTypology, projectDescription, setProjectDescription,
    projectArea, setProjectArea, projectStatus, setProjectStatus, projectDate,
    setProjectDate, projectSubCategory, setProjectSubCategory, subCategoryList,
    fullRawImage, setFullRawImage, cardImage, setCardImage, cardRawImage,
    setCardRawImage, fullImage, setFullImage, oldProjectData, editMode, projectCategory,
    loading, setSelectedTeam,selectedTeam
  } = props;

  const { allTeam } = useContext(TeamContext);
  const theme = useTheme();

  const handelSubmit = (e) => {
    e.preventDefault();
    const descriptionHtml = JSON.stringify(convertToRaw(projectDescription.getCurrentContent()));
    const data = {
      companyName: companyName,
      projectDescription: descriptionHtml,
      projectArea: projectArea,
      projectDate: projectDate,
      projectLoaction: projectLoaction,
      projectStatus: projectStatus,
      projectTypology: projectTypology,
      projectGallaryImages: projectGallaryRawImages,
      cardImage: cardRawImage.file,
      fullImage: projectGallaryRawImages[0].file,
      projectSubCategory: projectSubCategory,
      team: selectedTeam,
    };

    handlerFunction(data, id, oldProjectData);
    handleClose();
    setProjectGallaryImages(null);
    setCardImage(null);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle>
        <Typography
          variant={"h6"}
          style={{ color: PRIMARY_COLOR_DarkNavyBlue, fontWeight: "600" }}
        >
          {`${
            editMode
              ? "Edit"
              : `Add ${
                  projectCategory?.charAt(0).toUpperCase() +
                  projectCategory?.slice(1).toLowerCase()
                }`
          } Project`}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <form onSubmit={handelSubmit}>
          <Grid container>
            <Grid item xs={12} sm={12} md={5}>
              <Box display={"flex"} gap={1} mb={1.5}>
                <AddCardImage
                  image={cardImage}
                  rawImage={cardRawImage}
                  isNewsFile={isNewsFile}
                  setImage={setCardImage}
                  setIsNewsFile={setIsNewsFile}
                  setRawImage={setCardRawImage}
                  editMode={editMode}
                />
              </Box>
              <Box display={"flex"} gap={1} mb={1.5}>
                <AddGallaryImages
                  Images={projectGallaryImages}
                  RawImages={projectGallaryRawImages}
                  isNewsFile={isNewsFile}
                  setImages={setProjectGallaryImages}
                  setIsNewsFile={setIsNewsFile}
                  setRawImages={setprojectGallaryRawImages}
                  setFullRawImage={setFullRawImage}
                  editMode={editMode}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={7}>
              <CustomTextField
                value={companyName}
                onValueChange={setCompanyName}
                labelName="Project Name"
                required
                style={{ marginBottom: 15 }}
              />
              <CustomTextField
                labelName={"Sub Category"}
                required
                onValueChange={setProjectSubCategory}
                value={projectSubCategory}
                fullWidth={true}
                select={true}
                data={subCategoryList}
                style={{ marginBottom: 15 }}
              />
              <CustomTextField
                value={projectTypology}
                onValueChange={setProjectTypology}
                labelName="Typology"
                type="text"
                required
                style={{ marginBottom: 15 }}
              />
              <CustomTextField
                value={projectArea}
                onValueChange={setProjectArea}
                labelName="Area"
                type="text"
                required
                style={{ marginBottom: 15 }}
              />
              <CustomTextField
                value={projectDate}
                onValueChange={setProjectDate}
                labelName="Year"
                type="text"
                required
                style={{ marginBottom: 15 }}
              />
              <CustomTextField
                labelName={"Status"}
                required
                value={projectStatus}
                onValueChange={setProjectStatus}
                fullWidth={true}
                select={true}
                data={["In Progress", "Completed"]}
                style={{ marginBottom: 15 }}
              />
              <CustomTextField
                value={projectLoaction}
                onValueChange={setProjectLoaction}
                labelName="Loaction"
                type="text"
                required
                style={{ marginBottom: 15 }}
              />
              {/*<CustomTextFieldWithChip*/}
              {/*  labelName="Team"*/}
              {/*  data={allTeam}*/}
              {/*  setSelectedTeam={setSelectedTeam}*/}
              {/*/>*/}
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Editor
                labelName={"Description"}
                type={"null"}
                value={projectDescription}
                onValueChange={setProjectDescription}
                editMode={editMode}
              />
            </Grid>
          </Grid>
          <div style={{ marginTop: 15 }}>
            <LoadingButton text={text} type={"submit"} loading={loading} />
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
